<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 用户信息
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">开票信息</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">添加开票信息</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 表单 -->
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="formBox">
				<div class="lable">单位名称</div>
				<div class="selFrom f-ct">
					<div class="itm" @click="invoiceType=3" :class="invoiceType==3?'a':''">
						<p class="t1">专用发票(单位)</p>
						<el-image v-if="invoiceType==3" class="sel" :src="require('@/static/icon67.png')"></el-image>
					</div>
					<div class="itm" @click="invoiceType=2" :class="invoiceType==2?'a':''">
						<p class="t1">普通发票(单位)</p>
						<el-image v-if="invoiceType==2" class="sel" :src="require('@/static/icon67.png')"></el-image>
					</div>
					<div class="itm" @click="invoiceType=1" :class="invoiceType==1?'a':''">
						<p class="t1">普通发票(个人)</p>
						<el-image v-if="invoiceType==1" class="sel" :src="require('@/static/icon67.png')"></el-image>
					</div>
				</div>
			</div>
			<div class="formBox">
				<div class="lable">发放类型：</div>
				<div class="selFrom f-ct">
					<div class="itm" @click="grantType=1" :class="grantType==1?'a':''">
						<p class="t1">电子发票</p>
						<el-image v-if="grantType==1" class="sel" :src="require('@/static/icon67.png')"></el-image>
					</div>
					<div class="itm" @click="grantType=2" :class="grantType==2?'a':''">
						<p class="t1">纸质发票</p>
						<el-image v-if="grantType==2" class="sel" :src="require('@/static/icon67.png')"></el-image>
					</div>
				</div>
			</div>
			
			<div class="formBox">
				<div class="lable">发票抬头</div>
				<div class="detail f-ct">
					<el-input type="text" v-model="title" placeholder="请输入发票抬头"></el-input>
				</div>
			</div>
			
			<template v-if="invoiceType==3">
				<div class="formBox">
					<div class="lable">纳税人识别号</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="code" placeholder="请输入纳税人识别号"></el-input>
					</div>
				</div>
				<div class="formBox">
					<div class="lable">单位地址</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="address" placeholder="请输入单位地址"></el-input>
					</div>
				</div>
				<div class="formBox">
					<div class="lable">单位联系电话</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="mobile" placeholder="请输入单位联系电话"></el-input>
					</div>
				</div>
				<div class="formBox">
					<div class="lable">开户行</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="openingBank" placeholder="请输入开户行"></el-input>
					</div>
				</div>
				<div class="formBox">
					<div class="lable">银行账号</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="bankAccount" placeholder="请输入银行账号"></el-input>
					</div>
				</div>
			</template>
			
			<template v-if="invoiceType==2">
				<div class="formBox">
					<div class="lable">纳税人识别号</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="code" placeholder="请输入纳税人识别号"></el-input>
					</div>
				</div>
				<div class="formBox">
					<div class="lable">邮箱</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="email" placeholder="请输入邮箱"></el-input>
					</div>
				</div>
			</template>
			
			
			<template v-if="invoiceType==1">
				<div class="formBox">
					<div class="lable">邮箱</div>
					<div class="detail f-ct">
						<el-input type="text" v-model="email" placeholder="请输入邮箱"></el-input>
					</div>
				</div>
			</template>
			
			<div class="formBox">
				<div class="lable">备注</div>
				<div class="detail f-ct">
					<el-input type="text" v-model="description" placeholder="请输入备注"></el-input>
				</div>
			</div>
			
			<div class="pageAnniuBox f-ct">
				<div class="b1" v-if="id" @click="submitAll">确认保存</div>
				<div class="b1" v-else @click="submitAll">确认添加</div>
				<div class="b2" @click="back()">返回</div>
			</div>
		</div>
	</div>
</template>
<script>
import { memberInvoiceadd,
memberInvoiceaddQY,
memberInvoicedetail,
memberInvoicedetailQY,
memberInvoiceupdate,
memberInvoiceupdateQY,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			invoiceType:3,
			grantType:1,
			// 表单内容
			title:'',
			name:'',
			code:'',
			mobile:'',
			address:'',
			openingBank:'',
			bankAccount:'',
			email:'',
			description:'',
		}
	},
	mounted() {
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		// 参数
		if(this.$route.query.id){
			this.id = this.$route.query.id
		}
		// 获取信息
		if(this.id){
			this.memberInvoicedetail()
		}
	},
	methods:{
		// 提交
		submitAll(){
			if(this.invoiceType==1){
				if(!this.title){this.Tips('请输入发票抬头','error');return}
				if(!this.email){this.Tips('请输入邮箱','error');return}
			}
			if(this.invoiceType==2){
				if(!this.title){this.Tips('请输入发票抬头','error');return}
				if(!this.code){this.Tips('纳税人识别号','error');return}
				if(!this.email){this.Tips('请输入邮箱','error');return}
			}
			if(this.invoiceType==3){
				if(!this.title){this.Tips('请输入发票抬头','error');return}
				if(!this.code){this.Tips('纳税人识别号','error');return}
				if(!this.address){this.Tips('请输入单位地址','error');return}
				if(!this.mobile){this.Tips('请输入单位联系电话','error');return}
				if(!this.openingBank){this.Tips('请输入开户行','error');return}
				if(!this.bankAccount){this.Tips('请输入银行账号','error');return}
			}
			if(this.userType == 1){
				this.submitXy()
			}
			if(this.userType == 2){
				this.submitXyQY()
			}
		},
		async submitXy(){
			let res;
			var data = {
				invoiceType:this.invoiceType,
				grantType:this.grantType,
				title:this.title,
				name:this.name,
				mobile:this.mobile,
				code:this.code,
				address:this.address,
				openingBank:this.openingBank,
				bankAccount:this.bankAccount,
				email:this.email,
				description:this.description,
			}
			if(this.id){
				data.id = this.id
				res = await memberInvoiceupdate(data);
			}else{
				res = await memberInvoiceadd(data);
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				setTimeout(()=>{
					this.back()
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		async submitXyQY(){
			let res;
			var data = {
				invoiceType:this.invoiceType,
				grantType:this.grantType,
				title:this.title,
				name:this.name,
				mobile:this.mobile,
				code:this.code,
				address:this.address,
				openingBank:this.openingBank,
				bankAccount:this.bankAccount,
				email:this.email,
				description:this.description,
			}
			if(this.id){
				data.id = this.id
				res = await memberInvoiceupdateQY(data);
			}else{
				res = await memberInvoiceaddQY(data);
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				setTimeout(()=>{
					this.back()
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		// 查询开票信息详情
		async memberInvoicedetail(){
			let res;
			if(this.userType==1){
				res = await memberInvoicedetail({id:this.id});
			}
			if(this.userType==2){
				res = await memberInvoicedetailQY({id:this.id});
			}
			if(res.code==200){
				this.invoiceType = res.data.invoiceType
				this.grantType = res.data.grantType
				this.title = res.data.title
				this.name = res.data.name
				this.code = res.data.code
				this.mobile = res.data.mobile
				this.address = res.data.address
				this.openingBank = res.data.openingBank
				this.bankAccount = res.data.bankAccount
				this.email = res.data.email
				this.description = res.data.description
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 32px;
	padding-bottom: 40px;
	padding-top: 20px;
	.pageAnniuBox{
		margin-top: 48px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
			cursor: pointer;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}
	.formBox{
		// width: 680px;
		display: flex;
		align-items: center;
		margin-bottom: 24px;
		.selFrom{
			margin-top: 16px;
			.tit{
				font-size: 16px;
				color: #4B5060;
			}
			.a{
				border: 2px solid #3B6492!important;
			}
			.itm{
				width: 190px;
				height: 46px;
				border: 1px solid #EFF1F6;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				border-radius: 4px;
				margin-right: 15px;
				cursor: pointer;
				.icon{
					width: 44px;
					height: 44px;
					margin-right: 14px;
				}
				.t1{
					font-size: 16px;
					color: #2F3541;
				}
				.sel{
					position: absolute;
					bottom: 0;
					right: 0;
					width: 31px;
					height: 24px;
				}
			}
		}
		.lable{
			width: 148px;
			font-size: 16px;
			color: #9A9DA7;
			// font-weight: bold;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			width: 599px;
			height: 46px;
			border-radius: 6px;
			border: 1px solid #E8EDF4;
			// background: #FBFCFF;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
		}
		.selAddr{
			.selAddrItm{
				width: 212px;
				height: 46px;
				border-radius: 6px;
				border: 1px solid #E8EDF4;
				background: #FBFCFF;
				margin-right: 22px;
				&:last-child{
					margin-right: 0;
				}
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					height: 44px;
					background: transparent;
				}
			}
		}
	}
}
</style>